import { Box, useTheme } from "@mui/material";
import * as React from "react";
import { GlobalMonitoringStatus } from "../type";

import { useMemo } from "react";

type RealTimeConnectorProps = {
  status: GlobalMonitoringStatus;
};

const RealTimeConnector = (
  props: React.PropsWithChildren<RealTimeConnectorProps>
) => {
  const theme = useTheme();

  const { status } = props;

  const StatusComputeStyle = useMemo(() => {
    switch (status) {
      case "paused":
        return {
          backgroundColor: theme.palette.device.border,
        };
      case "meeting":
        return { backgroundColor: theme.palette.meeting.background };
      case "loading":
        return {
          backgroundColor: theme.palette.grey[500],
          animation: "$connectorPulsating 2s infinite",
        };
      default:
        return { backgroundColor: theme.palette.primary.main };
    }
  }, [status, theme]);
  return (
    <Box sx={{ display: "flex", flex: "1 0 auto", minWidth: "4rem" }}>
      <Box
        sx={{
          height: "1px",
          borderRadius: "1px",
          width: "100%",
          ...StatusComputeStyle,
        }}
      ></Box>
    </Box>
  );
};

export default RealTimeConnector;
